export default __webpack_public_path__ + "static/media/company-blue.70562dc7.svg";